import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { FileUploadService } from '../../services/file-upload.service';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';
import { NzMessageService } from 'ng-zorro-antd/message';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-upload-file-dialog',
    templateUrl: './upload-file-dialog.component.html',
    styleUrls: ['./upload-file-dialog.component.scss']
})
export class UploadFileDialogComponent implements OnInit {
    form: FormGroup;
    @Input() url: string;
    @Input() multiple = false;
    @Input() showMessage = true;
    @Input() message: string;
    @Input() responseHandler: any = null;
    private file: File;
    @Input() accept: string;
    @Input() showUploadList: any;

    constructor(
        private fb: FormBuilder,
        private modalRef: NzModalRef,
        private messageService: NzMessageService,
        private translateService: TranslateService,
        private uploadService: FileUploadService
    ) {
        this.form = fb.group({
            file: fb.control(null, [])
        });
    }

    ngOnInit(): void {
    }

    upload() {
        this.modalRef.close(this.file);
    }

    cancel() {
        this.modalRef.close();
    }

    handleChange($event: NzUploadChangeParam) {
        this.file = $event.file.originFileObj;
        if($event.file.status === 'done' && this.responseHandler)
            this.responseHandler($event.file.response);
            
        if ($event.file.status === 'done' && this.showMessage) {
            this.messageService.success(this.message || this.translateService.instant('Common.ImportSuccess'));
        }
    }
}
